import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import webClient from '../../core/web_client';
import { COUPONS_PATH } from '../../core/constants';
import { extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';

export const getCouponAction = createAsyncThunk(
    'coupon/getCouponAction',
    async (couponId, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.get(`${ COUPONS_PATH }/${ couponId }`);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const getCouponSlice = createSlice({
    name: 'getCouponSlice',
    initialState: DEFAULT_STATE,
    reducers: {
        invalidateCoupon() {
            return DEFAULT_STATE;
        }
    },
    extraReducers: builder => {
        builder.addCase(getCouponAction.pending, () => STATE__API__STARTED);
        builder.addCase(getCouponAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(getCouponAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const { invalidateCoupon } = getCouponSlice.actions;
export const getCouponState = (state) => state.coupon.getCoupon;
export default getCouponSlice.reducer;
